// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // defaultauth: 'fackbackend',
  defaultauth: 'firebase',
  appUrl: 'http://localhost:4200',
  firebaseConfig: {
    apiKey: 'AIzaSyAUPZfbLypT2zUljwYfIVZAEpM2DDd5AW0',
    authDomain: 'yuno-app-6a2ca.firebaseapp.com',
    projectId: 'yuno-app-6a2ca',
    storageBucket: 'yuno-app-6a2ca.appspot.com',
    messagingSenderId: '609809924001',
    appId: '1:609809924001:web:cd06b2dfa559ce105c55e0',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
